import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useCourseEdit } from '@/module/Author/Course/model/CourseQuery';
import { CourseSchema, courseSchema, defaultCourseValues } from '@/module/Author/Course/model/CourseSchema';

import { useAppNotification } from '@feature/utils';

import { CourseForm } from './CourseForm';
import { Course } from './model/CourseTypes';

interface CourseEditProps {
  course: Course;
}

const convert = (course: Course): CourseSchema => ({
  ...course,
});

export function CourseEdit(props: CourseEditProps) {
  const { course } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useCourseEdit(course.id);

  const notification = useAppNotification();
  const onSubmit = (values: CourseSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(course), [course]);
  const navigate = useNavigate();

  return (
    <CourseForm
      title={t('courses.form.title.edit')}
      schema={courseSchema}
      defaultValues={defaultCourseValues}
      isError={isError}
      isSuccess={isSuccess}
      values={values}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
